import { Outlet, createFileRoute, notFound } from '@tanstack/react-router'

import { hasPermissions } from '@/access-control/hasPermissions'
import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { PageContainer } from '@/app/manager/Layout'
import { CompanySettingsHeader } from '@/company/components/CompanySettings/CompanySettingsHeader'

export const Route = createFileRoute('/company/_management/settings')({
  beforeLoad: ({ context }) => {
    if (!hasPermissions(context.user, { to: 'configure-company' })) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <PageContainer py="10">
        <CompanySettingsHeader />
        <Outlet />
      </PageContainer>
    </CompanyPage>
  )
}
